import createReducer from '../../utils/createReducer';
import actions from './actions';

const initialState = {
    onboardingCompleted: false, // skip to landing page (create tripboard) of onboarding
    tripboardCreationStarted: false, // onboarding done, tripboard created. Route to the tripboard
    tripboardCreationNotComplete: false // user has seen their newly created tripboard, route normally.
};

const actionHandlers = {};

actionHandlers[actions.COMPLETED_TRIPBOARD_ONBOARDING] = (state) => {
    const newState = {
        ...state,
        onboardingCompleted: true
    };
    return newState;
};

actionHandlers[actions.STARTED_TRIPBOARD_CREATION] = (state) => {
    const newState = {
        ...state,
        tripboardCreationStarted: true,
        tripboardCreationNotComplete: true
    };
    return newState;
};

actionHandlers[actions.COMPLETED_TRIPBOARD_CREATION] = (state) => {
    const newState = {
        ...state,
        onboardingCompleted: true,
        tripboardCreationNotComplete: false
    };
    return newState;
};

actionHandlers[actions.INIT_ONBOARDING_FLAGS] = (state, {payload}) => {
    const newState = {
        ...state,
        ...payload
    };
    return newState;
};

actionHandlers[actions.RESET_ONBOARDING_FLAGS] = () => {
    return initialState;
};

export default createReducer(actionHandlers, initialState);



// WEBPACK FOOTER //
// ./src/universal/components/onboarding/onboarding-reducer.js